// Shared responsive class strings. Kept as literal strings in a src/ file so
// Tailwind's content scan still picks every class up.

/** Pass to shadcn's <DialogContent className=…>: below `sm` the centred
 *  modal becomes a bottom sheet - pinned to the bottom edge, full width,
 *  rounded top corners, sliding up from below, and padded clear of the
 *  phone's home-indicator safe area. From `sm` up it's the normal centred
 *  dialog. Done here rather than by editing components/ui/dialog.tsx, which
 *  the shadcn CLI owns (see CLAUDE.md). */
export const PHONE_SHEET_DIALOG =
  "max-sm:inset-x-0 max-sm:bottom-0 max-sm:top-auto max-sm:left-0 max-sm:max-w-none " +
  "max-sm:overflow-x-hidden " +
  "max-sm:translate-x-0 max-sm:translate-y-0 max-sm:max-h-[92dvh] max-sm:rounded-t-2xl " +
  "max-sm:border-x-0 max-sm:border-b-0 max-sm:pb-[calc(1.5rem+env(safe-area-inset-bottom))] " +
  "max-sm:data-[state=open]:slide-in-from-left-0 max-sm:data-[state=closed]:slide-out-to-left-0 " +
  "max-sm:data-[state=open]:slide-in-from-bottom max-sm:data-[state=closed]:slide-out-to-bottom " +
  "max-sm:data-[state=open]:zoom-in-100 max-sm:data-[state=closed]:zoom-out-100";

/** Pass to <DialogFooter className=…>: shadcn stacks footer buttons
 *  (column-reverse) below `sm` with no gap between them; this adds one and
 *  makes them comfortable touch targets. */
export const PHONE_DIALOG_FOOTER = "max-sm:gap-2 max-sm:[&>button]:h-11";
